// components
import {
  SidebarProvider,
  useSidebar,
  Sidebar,
  SidebarButtonHome,
} from "@shared/Sidebar";
import { CountryDropdown } from "@pages/HomePage/components/SidebarHome/components/CountryDropdown";

export const SidebarRules = () => {
  const sidebar = useSidebar();

  return (
    <SidebarProvider value={sidebar}>
      <Sidebar>
        <div
          className="d-flex flex-column h-100 "
          data-testid="sidebar-rules"
        >
          <div className="d-flex flex-column gap-3 h-100 justify-content-between">
            <div className="d-flex flex-column gap-3">
              <SidebarButtonHome />
            </div>
            <div className="d-flex flex-column gap-3">
              <CountryDropdown />
            </div>
          </div>
        </div>
      </Sidebar>
    </SidebarProvider>
  );
};

